export const UserSpecialFunctionTypeEnum = {
  CPC_import: 'CPC_import',
  EMPLOYEE_COMMUTE_import: 'EMPLOYEE_COMMUTE_import',
  THSRC_import: 'THSRC_import',
  member_import: 'member_import',
}
